import { register } from '!/repository'
import { nay, T } from '@/helpers'
import { api } from '@setplex/tria-api'
import { createEvent, restore, sample } from 'effector'
import { not } from 'patronum'
import { model as tvShowModel } from '~/entities/shows'
import { model as tvShowBundleModel } from '~/entities/shows/bundles'
import { model as paymentModel } from '~/features/payment/generic'
import { genPagesLogicNew } from '~/shared/effector'

// *
// * EVENTS
// *

export const initShowsBundlePage = createEvent<{
  bundleId: number
  query: URLSearchParams
}>()
export const left = createEvent()

/** Skeleton start*/
export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

/** Skeleton end*/

// *
// * CONNECTIONS
// *

// vod
sample({
  clock: initShowsBundlePage,
  filter: not(api.showBundles.loadShowBundleWithContentFx.pending),
  fn: (clockData) => ({ ...clockData, page: 0 }),
  target: api.showBundles.loadShowBundleWithContentFx,
})

/********** Skeleton logics starts ***********/

sample({
  clock: initShowsBundlePage,
  fn: T,
  target: setContentLoading,
})

sample({
  clock: api.showBundles.loadShowBundleWithContentFx.pending,
  filter: nay,
  target: setContentLoading,
})

/********** Skeleton logics ends ***********/

export const loadMoreShowBundleContent = genPagesLogicNew(
  api.showBundles.$showBundleWithContentPageInfo,
  api.showBundles.paginateShowBundleWithContent
)

// *
// * STORES
// *

// clear paginatable stores
api.showBundles.$showBundleWithContent.reset(initShowsBundlePage)

register(loadMoreShowBundleContent, 'loadMoreShowBundleContent')
register(tvShowModel.updateTvShow, 'shows/updateTvShow')
register(
  tvShowBundleModel.$showBundleWithContentFormatted,
  '$showBundleWithContent'
)
register(
  paymentModel.selectTvShowBundlePaymentButton,
  'selectTvShowBundlePaymentButton'
)
register(paymentModel.selectTvShowPaymentButton, 'selectTvShowPaymentButton')
